import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const treatments = [
    {
        title: "Uleierea și ceruirea pardoselilor din lemn",
        text: "Sunt metode de finisare naturală ce hidratează, protejează și pun în valoare textura lemnului, oferind o strălucire mătăsoasă. Uleiul pătrunde în pori și oferă rezistență la umiditate și zgârieturi, în timp ce ceara adaugă un plus de protecție și luciu.",
    },
    {
        title: "Sigilarea polimerică",
        text: "Se aplică pe pardoseli lavabile, netede și dure, precum cele din linoleum, PVC, cauciuc, piatră naturală și mozaic, pentru a le proteja, restaura și a le conferi un luciu intens și rezistență sporită la uzură și trafic. Este ideală pentru zonele cu circulație intensă.",
    },
    {
        title: "Impermeabilizarea pardoselilor",
        text: "Implică aplicarea unor soluții hidrofuge pentru protejarea suprafeței împotriva apei, umezelii și substanțelor uleioase, prevenind infiltrațiile și deteriorarea. Este esențială pentru băi, terase și gresie. După curățarea în profunzime, soluția se aplică pe o suprafață curată și uscată.",
    },
    {
        title: "Recristalizarea pardoselilor",
        text: "Este recomandată în special pentru marmură, travertin și granit. Prin reacții chimice și frecare mecanică, procesul creează un strat molecular dur, lucios și rezistent la uzură, întărește suprafața și îi redă aspectul cristalin. Se realizează după șlefuire și înaintea aplicării tratamentului final, pentru obținerea unui finisaj de oglindă.",
    },
];

function TestimonialsHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Tratamente profesionale pentru întreținerea pardoselilor
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4} sx={{ textWrap: "pretty" }}>
                        Serviciile noastre de întreținere prin tratamente aplicate pardoselilor
                        includ procedee profesionale care mențin și redau frumusețea suprafețelor.
                        Lustruirea mecanizată, aplicată după curățare, păstrează aspectul de nou al
                        pardoselilor lucioase, iar ceruirea oferă protecție tehnică și estetică,
                        ideală pentru zonele cu trafic intens. Polisarea și sigilarea manuală
                        acoperă porii și creează un finisaj lucios și durabil, în timp ce
                        recondiționarea completă prin șlefuire cu pietre diamantate readuce luciul
                        inițial și repară suprafețele deteriorate.
                    </MKTypography>

                    {treatments.map(({ title, text }) => (
                        <MKBox key={title} mb={3}>
                            <MKTypography
                                variant="h3"
                                color="dark"
                                mb={1.5}
                                sx={{ textWrap: "balance" }}
                            >
                                {title}
                            </MKTypography>
                            <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                                {text}
                            </MKTypography>
                        </MKBox>
                    ))}
                </Grid>
            </Container>
        </MKBox>
    );
}

export default TestimonialsHome;
